<div class="search-wrapper {{searchBarClass}}" *transloco="let t" [class.transparent]="isTransparent">
  <div class="search-input-holder">
    <input type="text" value="{{inputValue}}" class="form-control" placeholder={{searchPlaceholder}} spellcheck="false"
      id="searchQuery" (input)="onInput($event)">
    <div>
      @if(!isLoading && !isTransparent){
        <i class="bi bi-search"></i>
      }
      @if(!isLoading && isTransparent){
        <img src="assets/img/svg/search_icon_white.svg" alt="Search"
        class="search-img" />
      }
      @if(isLoading){
        <div class="css-speeding-wheel"></div>
      }
    </div>
  </div>
  @if(items.length > 0){
    <div>
      <div class="list-group-wrapper">
        <div class="list-group">
          @for(item of items; track item){
          <div>
            <a (click)="selectItem(item)" class="list-group-item list-group-item-action flex-column align-items-start">
              <div class="d-flex w-100 flex-column">
                <p class="mb-1 fs-20 fw-lighter">{{item.name}}</p>
              </div>
            </a>
          </div>
          }
        </div>
      </div>
    </div>
  }
  
  @if(showEmptyState ?? false){
  <div class="list-group-wrapper">
    <div class="list-group">
      <a class="list-group-item list-group-item-action flex-column align-items-start">
        <div class="d-flex w-100 justify-content-between">
          <p class="mb-1 fs-20 fw-lighter">{{t('emptyState.list.results')}}</p>
        </div>
      </a>
    </div>
  </div>
  }
</div>